var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#000",
    transform: "rotate(-180 20 20)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M2.5 20c0-4.832 1.959-9.207 5.126-12.374C10.793 4.459 15.168 2.5 20 2.5c4.832 0 9.207 1.959 12.374 5.126C35.541 10.793 37.5 15.168 37.5 20c0 4.832-1.959 9.207-5.126 12.374C29.207 35.541 24.832 37.5 20 37.5c-6.26 0-11.75-3.286-14.844-8.227C3.473 26.584 2.5 23.406 2.5 20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20.724 26.659L14.408 30.044 15.615 22.875 10.505 17.799 17.566 16.753 20.724 10.231 23.883 16.753 30.944 17.799 25.834 22.875 27.041 30.044z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M19.931 27.13L13.259 30.883 14.597 23.048 9.276 17.556 16.708 16.348 20.091 9.2 23.347 16.288 30.759 17.363 25.338 22.952 26.537 30.764z",
    transform: "rotate(-35 20.017 20.042)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoost);
export default __webpack_public_path__ + "static/media/boost.6133c1bea917a858d0e204e9d6953117.svg";
export { ForwardRef as ReactComponent };